import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// import { getStyleSheet } from '../../global-styles';
import { shallow } from '@qcx/store';
import { useImageStore } from '../Image/image.store';
export const UIHeadElements = () => {
    const imageLoaderUrl = useImageStore(s => s.loaderOptions.url, shallow);
    return (_jsxs(_Fragment, { children: [_jsx("link", { href: imageLoaderUrl, rel: "preconnect" }), _jsx("style", { id: "stitches", dangerouslySetInnerHTML: {
                    __html: ''
                }, suppressHydrationWarning: true })] }));
};
